// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentListPanel-module_document_table_skQpS {
  width: 100%;
  min-width: 400px;
  border-spacing: 8px 10px;
  border-collapse: unset;
}

.DocumentListPanel-module_document_table_condensed_Te5BJ {
  min-width: 200px;
  border-spacing: 44px 4px;
  border-collapse: unset;
  margin-left: auto;
  margin-right: auto;
}

.DocumentListPanel-module_button_group_MthTA {
  max-width: 54px;
  display: flex;
  align-items: center;
}

.DocumentListPanel-module_document_table_skQpS td,
.DocumentListPanel-module_document_table_skQpS th {
  max-width: 280px;
}

.DocumentListPanel-module_document_table_skQpS td,
.DocumentListPanel-module_document_table_skQpS td > span {
  vertical-align: middle;
  white-space: nowrap;
  overflow-x: hidden;
}

.DocumentListPanel-module_table_header_cell_uZ9qT {
  vertical-align: bottom;
  font-weight: 600;
  white-space: nowrap;
}

.DocumentListPanel-module_centered_YTcfw {
  text-align: center;
}

.DocumentListPanel-module_file_input_JGA_R {
  white-space: nowrap;
  overflow-x: hidden;
}

.DocumentListPanel-module_file_input_container_p9tgh {
  width: 100%;
  display: grid;
  place-content: center;
  margin-top: 20px;
}

.DocumentListPanel-module_upload_button_container_Xtbh4 {
  width: 100%;
  margin-top: 12px;
  display: grid;
  place-content: end;
}

.DocumentListPanel-module_upload_button_iRh3P {
  color: white;
  background-color: var(--uu-utah-red);
}

.DocumentListPanel-module_upload_button_iRh3P:hover {
  background-color: var(--uu-utah-red-hover);
}

.DocumentListPanel-module_associated_docs_header_rjSn6 {
  text-align: center;
  padding-top: 30px;
  font-style: italic;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Documents/DocumentListPanel.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EAEE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".document_table {\n  width: 100%;\n  min-width: 400px;\n  border-spacing: 8px 10px;\n  border-collapse: unset;\n}\n\n.document_table_condensed {\n  composes: document_table;\n  min-width: 200px;\n  border-spacing: 44px 4px;\n  border-collapse: unset;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.button_group {\n  max-width: 54px;\n  display: flex;\n  align-items: center;\n}\n\n.document_table td,\n.document_table th {\n  max-width: 280px;\n}\n\n.document_table td,\n.document_table td > span {\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n\n.table_header_cell {\n  vertical-align: bottom;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.centered {\n  text-align: center;\n}\n\n.file_input {\n  composes: muted_text from 'Styles/colors.module.css';\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n\n.file_input_container {\n  width: 100%;\n  display: grid;\n  place-content: center;\n  margin-top: 20px;\n}\n\n.upload_button_container {\n  width: 100%;\n  margin-top: 12px;\n  display: grid;\n  place-content: end;\n}\n\n.upload_button {\n  composes: bos_button from 'Styles/styles.module.css';\n  color: white;\n  background-color: var(--uu-utah-red);\n}\n\n.upload_button:hover {\n  background-color: var(--uu-utah-red-hover);\n}\n\n.associated_docs_header {\n  composes: muted_text from 'Styles/colors.module.css';\n  text-align: center;\n  padding-top: 30px;\n  font-style: italic;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"document_table": `DocumentListPanel-module_document_table_skQpS`,
	"document_table_condensed": `DocumentListPanel-module_document_table_condensed_Te5BJ DocumentListPanel-module_document_table_skQpS`,
	"button_group": `DocumentListPanel-module_button_group_MthTA`,
	"table_header_cell": `DocumentListPanel-module_table_header_cell_uZ9qT`,
	"centered": `DocumentListPanel-module_centered_YTcfw`,
	"file_input": `DocumentListPanel-module_file_input_JGA_R ${___CSS_LOADER_ICSS_IMPORT_0___.locals["muted_text"]}`,
	"file_input_container": `DocumentListPanel-module_file_input_container_p9tgh`,
	"upload_button_container": `DocumentListPanel-module_upload_button_container_Xtbh4`,
	"upload_button": `DocumentListPanel-module_upload_button_iRh3P ${___CSS_LOADER_ICSS_IMPORT_1___.locals["bos_button"]}`,
	"associated_docs_header": `DocumentListPanel-module_associated_docs_header_rjSn6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["muted_text"]}`
};
export default ___CSS_LOADER_EXPORT___;
